<template>
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      :style="iconStyle" class='fill-current' viewBox="0 0 210.000000 67.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,67.000000) scale(0.100000,-0.100000)"
        stroke="none">
        <path d="M186 655 c-68 -24 -136 -109 -136 -170 l0 -25 1006 0 1006 0 -7 33
        c-12 58 -53 115 -103 144 l-47 28 -840 2 c-696 2 -847 0 -879 -12z"/>
        <path d="M3 404 c-3 -9 0 -20 8 -25 8 -5 463 -9 1040 -9 1051 0 1068 1 1038
        37 -9 11 -200 13 -1046 13 -938 0 -1034 -1 -1040 -16z"/>
        <path d="M130 347 c-63 -33 -111 -71 -108 -86 6 -28 35 -23 90 13 29 20 56 36
        61 36 4 0 31 -16 60 -35 28 -19 58 -35 65 -35 7 0 36 16 65 35 28 19 56 35 62
        35 6 0 34 -16 62 -35 29 -19 58 -35 65 -35 7 0 38 16 68 37 l54 36 30 -18 c17
        -10 47 -27 67 -39 l37 -20 56 37 c31 20 60 37 66 37 6 0 35 -17 66 -37 l56
        -37 37 20 c20 12 50 29 67 39 l30 18 54 -36 c30 -21 61 -37 68 -37 7 0 36 16
        65 35 28 19 56 35 62 35 6 0 34 -16 62 -35 29 -19 58 -35 65 -35 7 0 38 16 68
        37 l54 36 30 -18 c17 -10 47 -27 67 -39 l37 -20 56 37 c31 20 60 37 66 37 6 0
        35 -16 64 -36 39 -26 61 -34 76 -29 12 4 19 12 18 18 -7 22 -129 97 -157 97
        -15 0 -49 -14 -76 -31 -52 -33 -48 -33 -125 11 -47 27 -68 25 -125 -11 -52
        -33 -48 -33 -125 11 -44 25 -66 25 -110 0 -77 -44 -73 -44 -125 -11 -57 36
        -78 38 -125 11 -77 -44 -73 -44 -125 -11 -61 39 -89 39 -150 0 -52 -33 -48
        -33 -125 11 -47 27 -68 25 -125 -11 -52 -33 -48 -33 -125 11 -44 25 -66 25
        -110 0 -77 -44 -73 -44 -125 -11 -54 34 -77 38 -115 18z"/>
        <path d="M1375 195 c-8 -19 -22 -52 -31 -72 l-16 -38 -57 63 -56 62 -582 0
        -583 0 0 -25 c0 -65 77 -155 149 -175 27 -7 307 -10 873 -8 l833 3 47 28 c50
        29 91 86 103 145 l7 32 -105 0 -105 0 -17 -52 c-10 -29 -20 -56 -24 -60 -3 -4
        -39 23 -80 58 -40 36 -74 64 -76 62 -1 -2 -27 -38 -58 -81 l-55 -78 -73 86
        c-40 47 -74 85 -76 85 -1 0 -10 -16 -18 -35z"/>
      </g>
    </svg>

</template>

<script>
export default {
  name: 'SandwichSvg',
  components: {
  },
  props: {
    width: {
      type: [Number, String],
      default: 25
    },
    height: {
      type: [Number, String],
      default: 25
    }
  },
  computed: {
    iconStyle() {
      const { width, height } = this;
      return {
        width: `${width}px`,
        height: `${height}px`
      };
    }
  }
};
</script>
